import React from 'react';
import useMobileView from 'enhancers/use-mobile-view';
import { navigateToSignup } from 'pages/shared/utils';

import { getVideoUrl } from './utils';
import UI from './video-dreams-banner.ui';

const VideoDreamsBanner: React.FunctionComponent<unknown> = () => {
  const isMobileView = useMobileView();
  const videoUrl = getVideoUrl(isMobileView);

  const handleClickSignUp = React.useCallback(() => {
    navigateToSignup();
  }, []);

  return <UI videoUrl={videoUrl} onSignUp={handleClickSignUp} />;
};

export default VideoDreamsBanner;
